
import React from "react";
import { motion } from "framer-motion";

const Plans = () => {
  const achievements = [
    {
      title: "Sistema de Seguridad",
      description: "Renovación de la concesionaria de seguridad",
      date: "2024"
    },
    {
      title: "Jardinería",
      description: "Convenio con el Ayuntamiento para retirada de residuos verdes y cesión por parte del Ayuntamiento de una barredora - trabajador municipal incluido - para la limpieza de las calles de El Coto",
      date: "2024"
    },
    {
      title: "Gestión Eficiente",
      description: "Reducción de deuda, bajada de cuota comunitaria y racionalización de gastos superfluos",
      date: "2024"
    }
  ];

  const futurePlans = [
    {
      title: "Parques Infantiles y Zonas de Paseo",
      description: "A través de nuestra retomada relación con el Ayuntamiento trabajaremos para que las infraestructuras de El Coto sean un espacio para disfrutar",
      timeline: "2025"
    },
    {
      title: "Reducción de Deuda Comunitaria",
      description: "Continuaremos con la política de reducción de deuda y optimización de recursos",
      timeline: "2025"
    },
    {
      title: "Smart Community",
      description: "Implementación de tecnologías para una gestión más eficiente",
      timeline: "2026"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl font-bold text-primary mb-4">
            Logros y Planes de Futuro
          </h1>
          <p className="text-xl text-gray-600">
            Construyendo un mejor El Coto para todos
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Achievements */}
          <section>
            <h2 className="text-2xl font-bold mb-8">Logros Alcanzados</h2>
            <div className="space-y-8">
              {achievements.map((achievement, index) => (
                <motion.div
                  key={achievement.title}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2 }}
                  className="bg-white rounded-lg shadow-lg p-6"
                >
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-xl font-semibold">{achievement.title}</h3>
                    <span className="text-primary font-medium">
                      {achievement.date}
                    </span>
                  </div>
                  <p className="text-gray-600">{achievement.description}</p>
                </motion.div>
              ))}
            </div>
          </section>

          {/* Future Plans */}
          <section>
            <h2 className="text-2xl font-bold mb-8">Planes de Futuro</h2>
            <div className="space-y-8">
              {futurePlans.map((plan, index) => (
                <motion.div
                  key={plan.title}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2 }}
                  className="bg-white rounded-lg shadow-lg p-6"
                >
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-xl font-semibold">{plan.title}</h3>
                    <span className="text-primary font-medium">
                      {plan.timeline}
                    </span>
                  </div>
                  <p className="text-gray-600">{plan.description}</p>
                </motion.div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Plans;
